export function siteFilterChanges() {
    let form = document.querySelector('.filter__container'),
        container = document.querySelector('.js-load-more-list'),
        btn = document.querySelector('.js-load-more-btn')

    if (!form || !container || !btn) {
        return;
    }

    let inputs = form.querySelectorAll('input, select');

    inputs.forEach((input) => {
        input.addEventListener('change', function () {
            document.querySelector('.js-load-more-list').textContent = ''

            let formData = new FormData(form),
                currentPaged = 0;

            formData.append('action', 'load_more_posts');
            formData.append('_wpnonce', ajax_object.wp_nonce);
            formData.append('post_type', btn.dataset.postType);
            formData.append('number_of_pages', btn.dataset.numberOfPages);
            formData.append('current_paged', currentPaged);

            load_filtered_data(formData);
        });
    })
}

function load_filtered_data(data) {
    let request = new XMLHttpRequest(),
        method = 'POST',
        url = ajax_object.ajax_url;

    request.open(method, url, true);

    request.onload = function () {
        let response = JSON.parse(this.response).data,
            content = document.querySelector('.js-load-more-list'),
            btn = document.querySelector('.js-load-more-btn')

        if (response.paged >= response.numberOfPages) {
            btn.classList.add('btn-disabled');
        } else {
            btn.classList.remove('btn-disabled');
        }

        content.innerHTML += response.html;
        btn.dataset.currentPaged = response.paged;
        btn.dataset.numberOfPages = response.numberOfPages;
    }

    request.onerror = function () {
        console.log(this.response);
    }

    request.send(data)
}
